<template>
    <div id="content_right_top" style="width: 440px;height: 393px;">

    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    name: 'contentRightTop',
    props:{
        rankData:{
            type: Object,
			      default: () => { }
        }
    },
    mounted() {
        const chartContainer = document.getElementById('content_right_top');
        const chart = echarts.init(chartContainer);
        // 原始数据和颜色
        const list = this.rankData.ranki

        const colors = [this.rankData.color.A,this.rankData.color.B,this.rankData.color.C,this.rankData.color.D]
        // 计算插入的数据的值
        const options = {
            title: {
                text: '专利评级分布图',
                left: 'center',
                top: '0',
                textStyle: {
                    color: '#fff',
                    fontSize: 20,
                    fontWeight: 'bold'
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            series: [
                {
                    name: '专利等级',
                    type: 'pie',
                    selectedMode: 'single',
                    radius: [0, '30%'],
                    center: ['50%', '60%'],
                    padAngle: 1,
                    label: {
                        position: 'inner',
                        fontSize: 17,
                        color:'#fff',
                        fontWeight:'bold'
                    },
                    labelLine: {
                        show: false
                    },
                    itemStyle: {
                        color: (param) => {
                            return colors[param.dataIndex]
                        },
                    },
                    data: this.rankData.rankt
                },
                {
                    name: '专利等级',
                    type: 'pie',
                    padAngle: 1,
                    itemStyle: {
                        color: (param) => {
                            console.log('param', param)
                            return colors[param.data.colorIndex]
                        }
                    },
                    label: {
                        fontWeight:'bold',
                        color:'#fff',
                        position: 'inside',
                    },
                    radius: ['31%', '55%'],
                    center: ['50%', '60%'],
                    data: list
                },
                {
                    name: '专利等级',
                    type: 'pie',
                    padAngle: 1,
                    itemStyle: {
                        color: (param) => {
                            return colors[param.data.colorIndex]
                        }
                    },
                    radius: ['31%', '55%'],
                    center: ['50%', '60%'],
                    label: {
                        formatter: (params) => {
                            return params.value +'件'
                        }
                    },
                    labelLine: {
                        show: true,
                        length: 30,
                        length2: 20,
                        lineStyle: {
                            color: '#fff'
                        },
                    },
                    data: list
                }
            ]
        };
        chart.setOption(options);
        chart.on('click',function(params){
          let name = params.data.name
          localStorage.setItem('consoleLeveli', name)
          window.open('#/patent/monitor','_blank')
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/views/console/components/contentRightTop.vue